import { render, staticRenderFns } from "./on-service-create-system-message.vue?vue&type=template&id=0a0d144a"
import script from "./on-service-create-system-message.vue?vue&type=script&lang=js"
export * from "./on-service-create-system-message.vue?vue&type=script&lang=js"
import style0 from "./on-service-create-system-message.vue?vue&type=style&index=0&id=0a0d144a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports